import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/birhane/projects/osce-livekit-meet-v2/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/birhane/projects/osce-livekit-meet-v2/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/home/birhane/projects/osce-livekit-meet-v2/node_modules/@livekit/components-styles/dist/general/index.css");
;
import(/* webpackMode: "eager" */ "/home/birhane/projects/osce-livekit-meet-v2/node_modules/@livekit/components-styles/dist/general/prefabs/index.css");
